export default (fn, threshhold, scope) => {
  const thres = threshhold || 250;

  let last;
  let deferTimer;

  return (...args) => {
    const context = scope || this;

    const now = +new Date();

    if (last && now < last + thres) {
      // hold on to it
      clearTimeout(deferTimer);

      deferTimer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, thres);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};
